// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"04f01bdb","488":"fbf3558c","644":"a5d93306","732":"3474ff9b"}[chunkId] + ".chunk.js";
};